import ajax from '@/resources/myApi';
import InventorySerialNumberDto from './dto';

const inventorySerialNumberService = {
  getAllForPart,
  getSerialNumberById,
};

async function getAllForPart(partId) {
  try {
    const result = await ajax.get(`api/GetSerialNumbers/${partId}`, {
      name: 'serial numbers',
    });

    return result.data.map((item) => new InventorySerialNumberDto(item));
  } catch {}
}

async function getSerialNumberById(id) {
  try {
    const { data } = await ajax.get(`api/GetSerialNumber/${id}`, {
      name: 'serial number',
    })
    return new InventorySerialNumberDto(data);
  } catch {}
}

export default inventorySerialNumberService;
